'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _lazyImage = require('linksoft/initializers/lazy-image');

var _lazyImage2 = _interopRequireDefault(_lazyImage);

var _linksoftAlbatros = require('linksoft-albatros');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

var mapDispatchToProps = {
    removeCoupon: _actions2.default.removeCoupon
};

var DiscountCoupon = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
    (0, _inherits3.default)(DiscountCoupon, _React$PureComponent);

    function DiscountCoupon(props) {
        (0, _classCallCheck3.default)(this, DiscountCoupon);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DiscountCoupon.__proto__ || (0, _getPrototypeOf2.default)(DiscountCoupon)).call(this, props));

        _this.handleDelete = function () {
            _this.props.removeCoupon();
        };

        _this.getRefuseReasonText = function (refuseReason) {
            if (!refuseReason) return '';
            return refuseReason.couponCode + ': ' + refuseReason.text;
        };

        _this.moreProductsForCoupon = function (event, component) {
            component.showMoreProductsToCouponApply = !component.showMoreProductsToCouponApply;
            component.forceUpdate();
        };

        _this.getProductRelatedCouponInfo = function (info, showMoreProducts) {
            var productsContent = void 0;
            var button = void 0;
            var component = _this;

            if (info.products.length < 4) {
                productsContent = _this.formatProductsForCoupon(info.products);
            } else {
                var products = showMoreProducts ? info.products : info.products.slice(0, 3);
                productsContent = _this.formatProductsForCoupon(products);
                button = _react2.default.createElement(
                    'a',
                    { className: 'link-button heavy', onClick: function onClick(event) {
                            return _this.moreProductsForCoupon(event, component);
                        } },
                    showMoreProducts ? ' \u25B2 ' + Resx.Common.Less : ' \u25BC ' + Resx.Common.More
                );
            }
            return _react2.default.createElement(
                'div',
                { className: 'coupon-refuse-info' },
                _react2.default.createElement(
                    'span',
                    null,
                    Resx.App.CouponAppliedIf
                ),
                ': ',
                productsContent,
                button
            );
        };

        _this.formatProductsForCoupon = function (productArray) {
            return productArray.map(function (p) {
                return _react2.default.createElement(
                    'span',
                    { key: 'fpf_' + p.id, className: 'product-for-coupon' },
                    _react2.default.createElement(
                        'a',
                        { key: 'fpfa_' + p.id, href: '/Product/Detail/' + p.id },
                        p.name
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'product-for-coupon-comma' },
                        ', '
                    )
                );
            });
        };

        _this.showMoreProductsToCouponApply = false;
        return _this;
    }

    (0, _createClass3.default)(DiscountCoupon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _lazyImage2.default)();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                code = _props.code,
                info = _props.info,
                refuseReason = _props.refuseReason;

            var display = code || refuseReason;
            if (!display) return null;

            var formattedDiscount = "";
            var detailedDiscountInfo = "";
            var formattedDiscountCss = "";
            if (info && !info.couponIsApplied) {
                formattedDiscount = refuseReason ? this.getRefuseReasonText(refuseReason) : Resx.App.CouponIsNotActivated;

                if ((info.products || []).length > 0) {
                    detailedDiscountInfo = this.getProductRelatedCouponInfo(info, this.showMoreProductsToCouponApply);
                }
                if ((info.authors || []).length > 0) {
                    detailedDiscountInfo = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            Resx.App.CouponAppliedIf,
                            ' ',
                            Resx.App.TitlesFromAuthor
                        ),
                        ': ',
                        info.authors.map(function (p) {
                            return _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'a',
                                    { href: '/Author/Detail/' + p.id },
                                    p.name
                                ),
                                ', '
                            );
                        })
                    );
                }

                formattedDiscountCss = "coupon__inactive";
            } else if (info && info.appliedValue > 0) formattedDiscount = '-' + (0, _linksoftAlbatros.formatPrice)(info.appliedValue, _linksoftAlbatros.PriceType.CartTotalPrice);
            // message assigned on coupon adding 
            else if ((!info || info && !info.couponIsApplied) && refuseReason && refuseReason.reason !== _linksoftAlbatros.CouponResponse.CodeNotFound) {
                    formattedDiscountCss = "coupon__inactive";
                    detailedDiscountInfo = this.getRefuseReasonText(refuseReason);
                }

            return _react2.default.createElement(
                'div',
                { className: 'cart__item cart__item--discount' },
                _react2.default.createElement(
                    'div',
                    { className: formattedDiscountCss },
                    Resx.App.DiscountCoupon,
                    ': ',
                    _react2.default.createElement(
                        'span',
                        { className: 'cart__coupon' },
                        _react2.default.createElement(
                            'span',
                            {
                                className: 'cart__coupon-code' },
                            code
                        ),
                        ' ',
                        name
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn__square cart-i__remove cart-i__remove', onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'icon--cross' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__summary' },
                        _react2.default.createElement(
                            'span',
                            null,
                            formattedDiscount
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'detailed-discount-info' },
                            detailedDiscountInfo
                        )
                    )
                )
            );
        }
    }]);
    return DiscountCoupon;
}(_react2.default.PureComponent)) || _class);
exports.default = DiscountCoupon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/DiscountCoupon.js
// module id = 1017
// module chunks = 0